import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardTimePicker as MaterialTimePicker } from '@material-ui/pickers';

const TimePicker = (props) => {
    return (
        <MaterialTimePicker label={props.label} invalidDateMessage="" emptyLabel=""
                            inputVariant="outlined" format="HH:mm"
                            variant="inline" ampm={false} disableToolbar={true} fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            value={props.value} onChange={props.onChange}
                            error={props.error}
                            helperText={props.helperText}
                            onFocus={props.onFocus}
                            placeholder={props.placeholder}
        />
    );
};

TimePicker.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
};

TimePicker.defaultProps = {
    error: false,
    helperText: '',
    placeholder: '',
};

export default TimePicker;
